import Routes from "./routes/ProjectRoutes"
import {ConfigProvider} from "antd"
import "moment/locale/fa"; 
import fa_IR from "antd/es/locale/fa_IR"; 
import "./App.scss"

function App() {
  return (
    <ConfigProvider direction='rtl' locale={fa_IR}>
        {/* <DatePicker defaultValue={moment('2015-01-01', 'YYYY-MM-DD')} /> */}
        {/* <DatePicker locale={locale} defaultValue={moment()} />  */}
    <Routes />
    </ConfigProvider>
  )
}

export default App;